import { manifests as examineManifests } from './examine-management-dashboard/manifests.js';
import UmbSearchHeaderAppElement from './umb-search-header-app.element.js';
import { UMB_SECTION_ALIAS_CONDITION_ALIAS } from '@umbraco-cms/backoffice/section';

export const manifests: Array<UmbExtensionManifest> = [
	{
		type: 'headerApp',
		alias: 'Umb.HeaderApp.Search',
		name: 'Header App Search',
		element: UmbSearchHeaderAppElement,
		weight: 900,
		meta: {
			label: 'Search',
			icon: 'search',
			pathname: 'search',
		},
	},
	{
		type: 'modal',
		alias: 'Umb.Modal.Search',
		name: 'Search Modal',
		element: () => import('./search-modal/search-modal.element.js'),
	},
	{
		type: 'dashboard',
		alias: 'Umb.Dashboard.ExamineManagement',
		name: 'Examine Management Dashboard',
		element: () => import('./examine-management-dashboard/dashboard-examine-management.element.js'),
		weight: 400,
		meta: {
			label: '#dashboardTabs_settingsExamine',
			pathname: 'examine-management',
		},
		conditions: [
			{
				alias: UMB_SECTION_ALIAS_CONDITION_ALIAS,
				/* TODO: kept as a magic string to avoid illegal import outside of core
					Move dashboard implementation out of core
				*/
				match: 'Umb.Section.Settings',
			},
		],
	},
	...examineManifests,
];
